<template>
  <div>
    <v-tabs v-model="tab"
            background-color="primary"
            dark
            grow
            style="height: 100%">
      <v-tab v-for="(item) in tabs"
             v-if="isAccessible(item)"
             :key="item.index"
             :disabled="$route.name !== item.componentPath"
             :to="{name: item.componentPath, query: {...$route.query}}">
        {{ item.name }}
      </v-tab>

      <v-tab-item :value="tab" class="pb-6">
        <v-sheet class="mx-auto" max-width="1230">
          <router-view
              :readonly="isLectureSeule"
              :routeName="routeName">
          </router-view>
        </v-sheet>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import { FormulaireReAdmission } from "@/utils/formulaireDefinitions"
import FormulaireMixin from "@/mixins/formulaireMixin"
import ParamFormulaire from "@/mixins/paramFormulaire"

export default {
  mixins: [FormulaireMixin, ParamFormulaire],
  props: {
    routeName: {
      type: String,
      default: FormulaireReAdmission.routeName,
    },
  },
  data () {
    return {
      tab: "",
      tabs: [],
    }
  },
  computed: {
    ...mapGetters({
      isLectureSeule: "DemandeAdmission/isLectureSeule",
    }),
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireReAdmission)
  },
  async created () {
    this.autoRedirect()
    await this.handleDemandeAdmission()

    this.tabs = FormulaireReAdmission.getTabs()
  },
  methods: {
    ...mapMutations({
      setDemandeAdmissionId: "DemandeAdmission/SET_ID",
      setContactId: "DemandeAdmission/SET_CONTACTID",
    }),
    ...mapActions({
      fetchDemandeAdmission: "DemandeAdmission/fetchDemandeAdmission",
    }),
    async handleDemandeAdmission () {
      if (this.$route.query.contactId == null) {
        this.$router.push({ name: "InternalError", params: { message: "Un contact est obligatoire" } })
      } else {
        this.setContactId(this.$route.query.contactId)
      }

      if (this.$route.query.demandeAdmissionId != null) {
        this.setDemandeAdmissionId(this.$route.query.demandeAdmissionId)
        await this.fetchDemandeAdmission(this.$route.query.demandeAdmissionId)
        // todo fetch autorisation ?
      }
    },
    autoRedirect () {
      if (this.$route.name == this.routeName) {
        this.$router.push({
          name: `${this.routeName}/RenseignementsGeneraux`, query: { ...this.$route.query }
        })
      }
    }
  },
}
</script>

<style>
</style>